import { React } from '@digsup/core-ui';
import { Icon } from '@digsup/components-icon';
import { Image } from '@digsup/components-image';

import { FeaturesItem } from './FeaturesItem';
import contactImg from './assets/contact.png';
import contact2xImg from './assets/contact@2x.png';
import contact3xImg from './assets/contact@3x.png';
import contactMobileImg from './assets/contact-mobile.png';
import contactMobile2xImg from './assets/contact-mobile@2x.png';
import contactMobile3xImg from './assets/contact-mobile@3x.png';

export const FeatureContact = () => (
  <FeaturesItem
    title="Contact owners"
    description={
      <>
        Send messages directly to owners;
        <br /> no 3rd party representatives in the way.
      </>
    }
    icon={
      <Icon
        name="letter-closed"
        size="xlarge"
        shape="round"
        fill="tenacious"
        shapeColor="tenacious-light"
      />
    }
    media={
      <div className="l-homepage-features__contact-media">
        <div className="l-homepage-features__contact-media-img">
          <Image
            src={contactImg}
            srcset={`
              ${contactMobileImg} 473w,
              ${contactImg} 528w,
              ${contactMobile2xImg} 946w,
              ${contact2xImg} 1056w,
              ${contactMobile3xImg} 1419w,
              ${contact3xImg} 1584w
            `}
            sizes="(max-width: 999px) 473px, 528px"
            placeholderImage=""
            alt="Contact owners"
          />
        </div>
      </div>
    }
  />
);
